var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50646 14.1667C1.08549 14.1667 0.729167 14.0208 0.4375 13.7292C0.145833 13.4375 0 13.0812 0 12.6602V1.50646C0 1.08549 0.145833 0.729167 0.4375 0.4375C0.729167 0.145833 1.08549 0 1.50646 0H7.09125V1.25H1.50646C1.44229 1.25 1.38354 1.27674 1.33021 1.33021C1.27674 1.38354 1.25 1.44229 1.25 1.50646V12.6602C1.25 12.7244 1.27674 12.7831 1.33021 12.8365C1.38354 12.8899 1.44229 12.9167 1.50646 12.9167H7.09125V14.1667H1.50646ZM10.609 10.641L9.74354 9.73708L11.7725 7.70833H4.66354V6.45833H11.7725L9.74354 4.42958L10.609 3.52562L14.1667 7.08333L10.609 10.641Z",
    fill: "#DA0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutNew);
export default __webpack_public_path__ + "static/media/LogoutNew.4fb3c2aecc21ee477af2acf64b933938.svg";
export { ForwardRef as ReactComponent };